<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Arrival/Departure Office Wise Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button :export-country="country" :export-date="range"
                                        model="arrival-departure-officewise"
                                        v-if="$oauth.checkIfHasPermission(['export arrival-departure-summary-report'])"/>
          <refresh-button :click-function="updateByOffice"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex class="d-flex align-center" xs6>
              <custom-date-range-picker @change="updateByOffice"
                                        v-model="range"/>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                  :items="passport_types"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  label="Passport types"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="passport_type"
                  @change="updateByOffice"
              />
            </v-flex>
          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read arrival-departure-summary-report'])"
            >
              <thead>
              <!--              <v-progress-linear-->
              <!--                  :active="progressLinearLoading"-->
              <!--                  :indeterminate="progressLinearLoading"-->
              <!--                  absolute-->
              <!--                  bottom-->
              <!--                  color="primary"-->
              <!--              ></v-progress-linear>-->
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th class="text-center" colspan="2" style="border-bottom: 1px solid lightgrey;"></th>
                <th class="text-center" colspan="4"
                    style="border-right: 1px solid lightgrey;border-bottom: 1px solid lightgrey;">
                  Arrival
                </th>
                <th class="text-center" colspan="4" style="border-bottom: 1px solid lightgrey;">
                  Departure
                </th>
              </tr>
              <tr>
                <th class="text-center">S.N</th>
                <th>Office Name</th>
                <th class="text-center">Male</th>
                <th class="text-center">Female</th>
                <th class="text-center">Other</th>
                <th class="text-center">Total</th>
                <th class="text-center">Male</th>
                <th class="text-center">Female</th>
                <th class="text-center">Other</th>
                <th class="text-center">Total</th>
              </tr>
              </thead>
              <tbody v-if="office_wise_data">
              <tr v-for="(item,i) in office_wise_data">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ item.office }}</td>
                <td class="text-center">{{ item.male_arrived }}</td>
                <td class="text-center">{{ item.female_arrived }}</td>
                <td class="text-center">{{ item.other_arrived }}</td>
                <td class="font-weight-bold text-center">{{ item.total_arrived }}</td>
                <td class="text-center">{{ item.male_departed }}</td>
                <td class="text-center">{{ item.female_departed }}</td>
                <td class="text-center">{{ item.other_departed }}</td>
                <td class="font-weight-bold text-center">{{ item.total_departed }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="2">Total</td>
                <td class="text-center">{{ total_male_arrival }}</td>
                <td class="text-center">{{ total_female_arrival }}</td>
                <td class="text-center">{{ total_other_arrival }}</td>
                <td class="text-center">{{ total_total_arrival }}</td>
                <td class="text-center">{{ total_male_departure }}</td>
                <td class="text-center">{{ total_female_departure }}</td>
                <td class="text-center">{{ total_other_departure }}</td>
                <td class="text-center">{{ total_total_departure }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td><h3 class="text-center">No record found</h3></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const AD_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/arrival-departure-officewise`;

export default {
  name: "ADOfficeWiseReport",
  data() {
    return {
      total_male_arrival: 0,
      total_female_arrival: 0,
      total_other_arrival: 0,
      total_total_arrival: 0,
      total_male_departure: 0,
      total_female_departure: 0,
      total_other_departure: 0,
      total_total_departure: 0,
      office_wise_data: [],
      range: {},
      country: [],
      passport_type: null,
      passport_types: ['Ordinary passport', 'Diplomatic Passport', 'Official/Service Passport', 'Laissez-passer Passport', 'Crew Passport'],
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
    }),
    from_main_office() {
      return this.$store.state.AuthUser.user.from_main_office;
    },
    offices() {
      return this.$store.state.OfficeList.offices;
    },

  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
      fetchOfficers: "UserList/getAll"
    }),
    arrivedReport(item) {
      let params = {fromAD: true, type: 'Arrival', country: item.country};
      this.$router.push({
        name: 'ArrivalDepartureReport',
        params: params
      });
    },

    departedReport(item) {
    },
    updateByOffice() {
      let params = {};
      this.progressLinearLoading = true;
      if (this.range)
        params.date_range = this.range;
      if (this.country)
        params.country = this.country;

      if (this.passport_type)
        params.passport_type = this.passport_type;

      this.total_male_arrival = 0;
      this.total_female_arrival = 0;
      this.total_other_arrival = 0;

      this.total_male_departure = 0;
      this.total_female_departure = 0;
      this.total_other_departure = 0;
      this.total_total_arrival = 0
      this.total_total_departure = 0
      Http.get(AD_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.office_wise_data = res.data.data;
            this.office_wise_data.forEach(item => {
              this.total_male_arrival += item.male_arrived;
              this.total_female_arrival += item.female_arrived;
              this.total_other_arrival += item.other_arrived;

              this.total_male_departure += item.male_departed;
              this.total_female_departure += item.female_departed;
              this.total_other_departure += item.other_departed;
            })
            this.total_total_arrival = this.total_other_arrival + this.total_female_arrival + this.total_male_arrival
            this.total_total_departure = this.total_other_departure + this.total_female_departure + this.total_male_departure
            this.progressLinearLoading = false;
            // this.getData();
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }


  },
  mounted() {
    this.progressLinearLoading = true;
    Http.get(AD_SUMMARY_REPORT_URL)
        .then((res) => {
          this.office_wise_data = res.data.data;
          this.office_wise_data.forEach(item => {
            this.total_male_arrival += item.male_arrived;
            this.total_female_arrival += item.female_arrived;
            this.total_other_arrival += item.other_arrived;

            this.total_male_departure += item.male_departed;
            this.total_female_departure += item.female_departed;
            this.total_other_departure += item.other_departed;
          })
          this.total_total_arrival = this.total_other_arrival + this.total_female_arrival + this.total_male_arrival
          this.total_total_departure = this.total_other_departure + this.total_female_departure + this.total_male_departure
          this.progressLinearLoading = false;
          // this.getData();
        })
        .catch(() => {
          this.progressLinearLoading = false;

        });
    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }

  }
}
</script>
